//
// Copyright (c) 2011-2021 by Curalate, Inc.
//

import { EditorState, Modifier } from 'draft-js';

import { SmartInputEntityType } from '@components/molecules/smart-input/smartInputModel';
import { ISmartInputContext } from '@components/molecules/smart-input/SmartInputContext';
import { getCurrentStateProperties } from '@components/molecules/smart-input/smartInputUtils';

/**
 * Updates the current editor state with the emoji to be added
 *
 * @param emoji The emoji string to be added
 * @param smartInputContext
 */
export const insertEmoji = (
  emoji: string,
  smartInputContext: ISmartInputContext,
) => {
  const editorState = smartInputContext.editor.getEditorState();

  const { currentContentState, currentSelectionState } =
    getCurrentStateProperties(editorState);

  const contentStateWithEmojiEntity = currentContentState.createEntity(
    SmartInputEntityType.Emoji,
    'MUTABLE',
    {
      value: emoji,
    },
  );
  const entityKey = contentStateWithEmojiEntity.getLastCreatedEntityKey();

  /**
   * Replaces the currently selected text with the emoji text
   */
  const emojiReplacedContent = Modifier.replaceText(
    currentContentState,
    currentSelectionState,
    emoji,
    undefined, // no inline styles necessary
    entityKey,
  );

  const newEditorState = EditorState.push(
    editorState,
    emojiReplacedContent,
    'insert-fragment',
  );

  smartInputContext.editor.setEditorState(
    EditorState.forceSelection(
      newEditorState,
      emojiReplacedContent.getSelectionAfter(),
    ),
    true,
  );
};
